import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 4V6H19V4H5ZM5 14H9V20H15V14H19L12 7L5 14Z",
		fill: "currentcolor"
	})
});
export default SvgUpload;
